module.exports = __webpack_public_path__ + "static/media/17.66f0c14f.jpg";